var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocketSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1907_11616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.47471 13.5867V12.3521H3.70939V11.1174H7.41345V12.3521H6.17876V13.5867H4.94408V14.8214H3.70939V17.2908H6.17876V16.0561H7.41345V14.8214H8.64813V13.5867H9.88281V17.2908H8.64813V18.5255H7.41345V19.7653H1.23484V13.5867H2.47471Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64844 14.8214H7.41375V16.056H6.17907V17.2907H3.7097V14.8214H4.94439V13.5867H6.17907V12.352H8.64844V14.8214Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8262 16.056H13.5863V17.2907H12.3516V18.5254H11.1169V14.8214H12.3516V13.5867H13.5863V12.352H14.8262V16.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8268 11.1174H16.0615V12.3521H14.8268V11.1174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0612 9.88263H17.2959V11.1173H16.0612V9.88263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5922 8.64801H16.0615V9.88269H13.5922V8.64801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2956 8.64801H18.5303V9.88269H17.2956V8.64801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88286 7.41328V6.1734H11.1175V4.93872H12.3522V7.41328H13.5869V8.64796H12.3522V9.88264H11.1175V11.1173H9.88286V12.352H8.64818V11.1173H7.41349V9.88264H2.47476V8.64796H3.70944V7.41328H4.94413V6.1734H8.64818V7.41328H9.88286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0612 7.41327H17.2959V8.64795H16.0612V7.41327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5309 7.41329H17.2963V4.93873H16.0616V3.70405H13.587V2.46936H12.3523V1.23468H19.7656V8.64797H18.5309V7.41329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64813 4.93872H9.88281V6.1734H8.64813V4.93872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8268 4.93872H16.0615V6.1734H14.8268V4.93872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8825 3.70404H11.1172V4.93872H9.8825V3.70404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3522 3.70404H13.5869V4.93872H12.3522V3.70404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1169 2.46936H12.3516V3.70404H11.1169V2.46936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23967 19.7654H7.41309V21H1.23967V19.7654Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41375 18.5255H8.64844V19.7601H7.41375V18.5255Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1169 18.5255H12.3516V19.7601H11.1169V18.5255Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88292 17.2908V13.5867H8.64823V12.3521H9.88292V11.1174H11.1176V9.88269H12.3523V8.64801H13.587V9.88269H16.0615V11.1174H14.8268V12.3521H13.587V13.5867H12.3523V14.8214H11.1176V18.5255H8.64823V17.2908H9.88292Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3522 17.2908H13.5869V18.5255H12.3522V17.2908Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5915 16.0561H14.8262V17.2907H13.5915V16.0561Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000308275 13.5867H1.23438V19.7601H-0.000308275V13.5867Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8268 12.352H16.0615V16.056H14.8268V12.352Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23993 12.352H2.47461V13.5867H1.23993V12.352Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41375 11.1174H8.64844V12.3521H7.41375V11.1174Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0612 11.1174H17.2959V12.3521H16.0612V11.1174Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41309 9.88263V11.1173H3.70903V12.352H2.47435V9.88263H7.41309Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2956 9.88263H18.5303V11.1173H17.2956V9.88263Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23993 8.64801H2.47461V9.88269H1.23993V8.64801Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0612 8.64801H17.2959V9.88269H16.0612V8.64801Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5309 8.64801H19.7656V9.88269H18.5309V8.64801Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4743 7.41327H3.70898V8.64795H2.4743V7.41327Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2956 7.41327H18.5303V8.64795H17.2956V7.41327Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70965 6.1734H4.94434V7.40808H3.70965V6.1734Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64813 6.1734H9.88281V7.40808H8.64813V6.1734Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.352 7.41328V4.93872H13.5867V3.70404H16.0612V4.93872H14.8265V6.17341H16.0612V4.93872H17.2959V7.41328H16.0612V8.64796H13.5867V7.41328H12.352Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7653 1.23468H21V8.64797H19.7653V1.23468Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94439 4.93872H8.64844V6.1734H4.94439V4.93872Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8825 4.93872H11.1172V6.1734H9.8825V4.93872Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64813 3.70404H9.88281V4.93872H8.64813V3.70404Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1169 3.70404H12.3516V4.93872H11.1169V3.70404Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8825 2.46936H11.1172V3.70404H9.8825V2.46936Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3522 2.46936H13.5869V3.70404H12.3522V2.46936Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1169 1.23468H12.3516V2.46936H11.1169V1.23468Z",
    fill: "#1E2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3523 0H19.7656V1.23468H12.3523V0Z",
    fill: "#1E2731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1907_11616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "matrix(-1 0 0 1 21 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketSmall);
export default __webpack_public_path__ + "static/media/rocketSmall.e6e55f475e5c2996009d702b38a20fa1.svg";
export { ForwardRef as ReactComponent };